/**
 * Reference list of jurisdictions accepted at intake. Includes the rules-engine
 * countries plus common low-risk jurisdictions seen in the historical CSV.
 * Maintained centrally so the intake form, audit list, and rules config share
 * the same vocabulary.
 */
export const COUNTRIES = [
  'United Kingdom',
  'Australia',
  'Belarus',
  'Brazil',
  'Canada',
  'China',
  'France',
  'Germany',
  'Italy',
  'Japan',
  'Mexico',
  'Netherlands',
  'Russia',
  'Singapore',
  'South Africa',
  'Spain',
  'Switzerland',
  'Turkey',
  'UAE',
  'United States',
  'Venezuela',
] as const;
